"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.DropdownMenu = void 0;
var react_1 = __importDefault(require("react"));
var useRovingTabIndex_1 = require("../../hooks/useRovingTabIndex");
var styles_1 = require("../../styles");
var react_2 = require("../../util/react");
function DropdownMenu(props) {
    var innerRef = props.innerRef, style = props.style, rest = __rest(props, ["innerRef", "style"]);
    var _a = styles_1.useStyles(exports.styles), css = _a.css, classes = _a.classes;
    var rootRef = useRovingTabIndex_1.useRovingTabIndex({
        getItems: function (root) { return Array.from(root.querySelectorAll('[role="menuitem"]:not([aria-disabled="true"])')); },
    });
    return react_1.default.createElement("ul", __assign({ ref: react_2.composeRefs(innerRef, rootRef), className: css(classes.root, style), role: 'menu' }, rest));
}
exports.DropdownMenu = DropdownMenu;
exports.styles = function (theme) { return ({
    root: {
        listStyle: 'none',
        margin: 0,
        padding: 'calc(0.5rem - 1px) 0',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.09)',
        border: "1px solid " + theme.pallete.divider,
        borderRadius: theme.radius.popper,
        display: 'inline-block',
        width: 'auto',
        minWidth: '150px',
        background: theme.pallete.surface.main,
    },
}); };
//# sourceMappingURL=DropdownMenu.js.map